import { render } from "./Button.vue?vue&type=template&id=c4877f3c&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=c4877f3c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c4877f3c"

export default script